import React, { useRef } from 'react';

interface ResizeHandleProps {
  onResize: (newHeight: number) => void;
  currentHeight: number;
}

export const ResizeHandle: React.FC<ResizeHandleProps> = ({ onResize, currentHeight }) => {
  const isDraggingRef = useRef(false);
  const startYRef = useRef(0);
  const startHeightRef = useRef(currentHeight);

  const handlePointerDown = (e: React.PointerEvent) => {
    e.preventDefault();
    isDraggingRef.current = true;
    startYRef.current = e.clientY;
    startHeightRef.current = currentHeight;

    const handlePointerMove = (moveEvent: PointerEvent) => {
      if (!isDraggingRef.current) return;
      const delta = moveEvent.clientY - startYRef.current;
      const newHeight = Math.max(140, Math.min(600, startHeightRef.current + delta));
      onResize(newHeight);
    };

    const handlePointerUp = () => {
      isDraggingRef.current = false;
      document.removeEventListener('pointermove', handlePointerMove);
      document.removeEventListener('pointerup', handlePointerUp);
    };

    document.addEventListener('pointermove', handlePointerMove);
    document.addEventListener('pointerup', handlePointerUp);
  };

  return (
    <div
      onPointerDown={handlePointerDown}
      title="Drag to resize Whiteboard / Media Pane"
      style={{
        height: '8px',
        backgroundColor: '#0b0f19',
        borderTop: '1px solid #1e293b',
        borderBottom: '1px solid #1e293b',
        cursor: 'row-resize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        zIndex: 40,
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: '36px',
          height: '3px',
          backgroundColor: '#334155',
          borderRadius: '2px',
        }}
      />
    </div>
  );
};
